import loadable from '@loadable/component';

// Lazy-loaded with SSR disabled: vanilla-cookieconsent requires browser environment
// and imports CSS that would crash Node.js SSR
export const CookieConsent = loadable(
  () => import(/* webpackChunkName: "CookieConsent" */ './CookieConsent'),
  { ssr: false }
);

export { hasAnalyticsConsent } from './analyticsLoader';
export { default as translations } from './translations.json';
